import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Applying the appearance prop directly to the children forgedocs.
 * It is because the logic for applying appearance to the children components
 * through React.cloneComponent can only be applied to the Forge component wrapper,
 * and not to the actual Button element.
 */
var applyAppearanceToChildren = function applyAppearanceToChildren(children, render, appearance) {
  if (!appearance) {
    return children.map(render);
  }
  return children.map(function (child) {
    if (child.type !== 'String') {
      return render(_objectSpread(_objectSpread({}, child), {}, {
        props: _objectSpread({
          appearance: appearance
        }, child.props)
      }));
    }
    return render(child);
  });
};

/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This component was generated against an existing platform component.
 * If you are seeing lint errors in this file, it means that this file's dependencies have been modified and the component will need to be regenerated.
 *
 * Please view https://hello.atlassian.net/wiki/spaces/ECO/pages/3358130330/How+to+Regenerate+UI+Kit+Components for more information on how to proceed.
 *
 * For further questions, please ping the #help-forge-ui channel.
 *
 * @codegen <<SignedSource::10523cdb8adecaa74cfa0b8cec0874b4>>
 * @codegenId #button-group
 * @codegenCommand yarn workspace @atlassian/forge-ui codegen button-group
 * @codegenParams { "defineOwnType": true, "customProps": ["appearance"], "props": { "children": { "value": "applyAppearanceToChildren(props.forgeDoc.children, props.render, appearance)", "comment": "apply consistent appearance to children elements" }, "testId": true, "label": true, "titleId": true } }
 * @codegenDependency ../../../../../../../design-system/button/src/containers/button-group.tsx <<SignedSource::b6fdd663bc4c5d4ce25292a9be241bbf>>
 */
/* eslint @repo/internal/codegen/signed-source-integrity: "warn" */
import React from 'react';
import { ButtonGroup as PlatformButtonGroup } from '@atlaskit/button';

// Define the type for ButtonGroup as ButtonGroupProps at the top of this file

export var ButtonGroup = function ButtonGroup(props) {
  var _ref = props.forgeDoc.props,
    testId = _ref.testId,
    label = _ref.label,
    titleId = _ref.titleId,
    appearance = _ref.appearance;
  return /*#__PURE__*/React.createElement(PlatformButtonGroup
  // apply consistent appearance to children elements
  , {
    children: applyAppearanceToChildren(props.forgeDoc.children, props.render, appearance),
    testId: testId,
    label: label,
    titleId: titleId
  });
};
/**
 * @codegenEnd
 */